import { Component, ojs, app } from "modular-openscriptjs";
import { either } from "../../helpers";

const h = app("h");
const $e = app("$e");

export default class OrderStatus extends Component {
    render(status, type, ...args) {
        return h.div(
            { class: "card border-0 shadow-sm rounded-4 mb-3" },
            h.div(
                { class: "card-body p-4" },
                h.h5({ class: "fw-bold mb-3 text-secondary" }, "Order Status"),
                h.div(
                    {
                        class: "progress",
                        style: "height: 12px; border-radius: 6px;",
                    },
                    h.div({
                        class: `progress-bar progress-bar-striped progress-bar-animated ${
                            this.classFromStatus(status)?.class
                        }`,
                        role: "progressbar",
                        style: this.classFromStatus(status)?.style,
                        aria_label: "Order Status",
                    }),
                ),
                h.div(
                    { class: "d-flex justify-content-between mt-2" },
                    h.small(
                        { class: "text-muted fw-bold text-uppercase" },
                        status?.replace("_", " "),
                    ),
                    h.small(
                        { class: "text-primary fw-bold" },
                        this.getPercent(status) + "%",
                    ),
                ),
                h.p(
                    {
                        class: "text-muted small mb-0 mt-3 border-top pt-2 fst-italic",
                    },
                    this.getDescription(status, type),
                ),
                this.notifyMe(),
            ),
            ...args,
        );
    }

    getDescription(status, type) {
        if (type === "delivery_request") {
            switch (status) {
                case "pending":
                    return "Your delivery request is waiting for payment.";
                case "confirmed":
                    return "We've received your request. We're assigning a deliverer.";
                case "processing":
                    return "A deliverer has accepted your request.";
                case "ready":
                    return "The delivery request has been placed and is being assigned to a deliverer.";
                case "delivering":
                    return "The deliverer is on his way, he has picked up the package and is now dropping it off.";
                case "completed":
                    return "The delivery request was completed successfully.";
                case "cancelled":
                    return "The delivery request was cancelled.";
                default:
                    return "";
            }
        }

        switch (status) {
            case "scheduled":
                return "The order has been scheduled.";
            case "pending":
                return "You've not paid for the order.";
            case "confirmed":
                return "You've paid for the order. It is waiting to be assigned.";
            case "processing":
                return "The order is currently being purchased, or the items are being purchased by the purchase coordinator.";
            case "ready":
                return "The purchase coordinator has finished purchasing all these items and is ready for the delivery.";
            case "delivering":
                return "The delivery is bringing the order to you.";
            case "completed":
                return "The order was completed.";
            case "cancelled":
                return "You cancelled the order.";
            case "dispute":
                return "The delivery thinks that the delivery fee is unfair and has requested an extra delivery fee.";
            default:
                return "";
        }
    }

    notifyMe() {
        if (!("Notification" in window)) return null;

        if (Notification.permission == "granted") return null;

        if (Notification.permission == "default") {
            return h.div(
                {
                    class: "form-check form-switch mt-3 d-flex align-items-center gap-2",
                },
                h.input(
                    {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "settings-turn-on-notification-order-track",
                        onclick: `sendEvent('${$e.system.needs.notificationPermission}')`,
                    },
                    either(
                        "Notification" in window &&
                            Notification.permission === "granted",
                        { checked: true },
                    ),
                ),
                h.label(
                    {
                        class: "form-check-label text-muted small",
                        for: "settings-turn-on-notification-order-track",
                    },
                    "Notify me of status changes",
                ),
            );
        }

        return h.div(
            {
                class: "alert alert-secondary mt-3 py-2 px-3 d-flex align-items-center gap-2",
            },
            h.i({ class: "bi bi-bell-slash" }),
            h.small("Notifications are blocked."),
        );
    }

    getPercent(status) {
        return this.classFromStatus(status)?.aria_valuenow || 0;
    }

    classFromStatus(status) {
        switch (status) {
            case "scheduled":
                return {
                    class: "bg-info",
                    style: "width: 20%",
                    aria_valuenow: "20",
                };
            case "pending":
                return {
                    class: "bg-info",
                    style: "width: 15%",
                    aria_valuenow: "15",
                };
            case "confirmed":
                return {
                    class: "bg-secondary",
                    style: "width: 30%",
                    aria_valuenow: "30",
                };
            case "dispute":
                return {
                    class: "bg-danger",
                    style: "width: 30%",
                    aria_valuenow: "30",
                };
            case "processing":
                return {
                    class: "bg-warning",
                    style: "width: 50%",
                    aria_valuenow: "50",
                };
            case "ready":
                return {
                    class: "bg-info",
                    style: "width: 70%",
                    aria_valuenow: "70",
                };
            case "delivering":
                return {
                    class: "bg-primary",
                    style: "width: 85%",
                    aria_valuenow: "85",
                };
            case "completed":
                return {
                    class: "bg-success",
                    style: "width: 100%",
                    aria_valuenow: "100",
                };
            case "cancelled":
                return {
                    class: "bg-danger",
                    style: "width: 100%",
                    aria_valuenow: "100",
                };
            default:
                return {
                    class: "bg-secondary",
                    style: "width: 5%",
                    aria_valuenow: "5",
                };
        }
    }
}

ojs(OrderStatus);
